import { pipe, reject, range, reduce, groupBy, mergeDeepRight } from 'ramda';
import moment from 'moment';
import { Timezones } from '@alycecom/modules';

import { DATE_FORMAT } from '../../../constants/dates.constants';
import { ISlot } from '../store/meeting/meeting.types';

const { UTC_ZONE } = Timezones.CONSTANTS;

const getWeekSlotsRange = (from: string) => {
  const days = range(0, 7);
  const date = moment(from);
  return reduce<number, Record<string, ISlot[]>>(
    (acc, addDays) => {
      const prop = date.clone().add(addDays, 'days').format(DATE_FORMAT);
      acc[prop] = [];
      return acc;
    },
    {},
    days,
  );
};

const filterSlotsByTimezone = (from: string, to: string, timezone: string): ((slots: ISlot[]) => ISlot[]) => {
  const fromDate = moment.utc(from).set({ hour: 0, minute: 0, second: 0 }).tz(UTC_ZONE);
  const toDate = moment.utc(to).set({ hour: 23, minute: 59, second: 59 }).tz(UTC_ZONE);

  const rejectFn = ({ startAt, endAt }: ISlot) => {
    const startAtWithZone = moment.utc(startAt).tz(timezone);
    const endAtWithZone = moment.utc(endAt).tz(timezone);
    return startAtWithZone.isBefore(fromDate) || endAtWithZone.isAfter(toDate);
  };

  return reject(rejectFn);
};

export const groupSlotsByDate = (
  timezone = Timezones.CONSTANTS.UTC_ZONE,
): ((slots: ISlot[]) => Record<string, ISlot[]>) =>
  groupBy(({ startAt }: ISlot) => moment.utc(startAt).tz(timezone).format(DATE_FORMAT));

export const getGroupedWeekSlots = (
  from: string,
  to: string,
  timezone: string,
): ((slots: ISlot[]) => Record<string, ISlot[]>) => {
  const weekSlots = getWeekSlotsRange(from);
  return pipe(filterSlotsByTimezone(from, to, timezone), groupSlotsByDate(timezone), mergeDeepRight(weekSlots)) as (
    slots: ISlot[],
  ) => Record<string, ISlot[]>;
};
